<script>
import { Pie } from 'vue-chartjs'

export default {
  extends: Pie,
  props:['labels','backgroundColors','chartData'],
  data:function(){
    return {
      options:{
        legend:{
          display:false,
        }
      }
    }
  },
  mounted () {
    this.renderChart({
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.backgroundColors,
          data: this.chartData
        }
      ]
    }, this.options)
  }
}
</script>
